import get from 'lodash/get'

export const isSelfServiceVideoCommunicationsEnabled = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  return !!channelData.features.find(({ name, enabled }) => name === 'enableSelfServiceVideoCommunications' && enabled === true)

}
